import { render, staticRenderFns } from "./AxFilesystemViewerActionsWorkspace.vue?vue&type=template&id=54eb098c&scoped=true&"
import script from "./AxFilesystemViewerActionsWorkspace.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemViewerActionsWorkspace.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemViewerActionsWorkspace.vue?vue&type=style&index=0&id=54eb098c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54eb098c",
  null
  
)

export default component.exports